import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightNumber } from '../../api/models';

export type TABLE_TYPE = Table<HeadWeightNumber>;

export const TABLE = 'headWeightNumber';
const SCHEMA = 'headWeightNumberId';

class HeadWeightNumberDatabase implements DataRepository<HeadWeightNumber> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightNumber | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightNumber, key: Key): Promise<HeadWeightNumber> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightNumber[]): Promise<HeadWeightNumber[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightNumber[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightNumberDB = new HeadWeightNumberDatabase(db);
